import { Injectable } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SosAlert, SosUser } from 'src/app/interfaces/user';
import { AuthService } from '../auth/auth.service';

import { firestore } from 'firebase/app';
@Injectable({
  providedIn: 'root'
})
export class SosService {

  public activeAlerts: SosAlert[] = [];
  public countAlerts = 0;

  private sosAlertsCollection: AngularFirestoreCollection<SosAlert>;
  private sosAlerts: Observable<SosAlert[]>;

  private sosUsersCollection: AngularFirestoreCollection<SosUser>;
  private sosUsers: Observable<SosUser[]>;

  constructor(private afs: AngularFirestore, private authServ: AuthService) {
    this.sosAlertsCollection = this.afs.collection<SosAlert>('sos_alerts',
      (ref) => {
        return ref.where('active', '==', true);
      });

    this.sosAlerts = this.sosAlertsCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as SosAlert;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );

    this.sosUsersCollection = this.afs.collection<SosUser>('sos_users');

    this.sosUsers = this.sosUsersCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as SosUser;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getAlerts(): Observable<SosAlert[]> {
    return this.sosAlerts;
  }

  getAlertDetail(id: string): Observable<SosAlert> {
    return this.afs.collection<SosAlert>('sos_alerts',
    (ref) => {
      return ref.where('id', '==', id).where('active', '==', true )
      .limit(1);
    }).doc<SosAlert>(id).valueChanges();
  }

  deactivateAlert(alert: SosAlert): Promise<void> {
    alert.finalized = {
      name: this.authServ.user.displayName,
      ref: this.authServ.userRef,
      ts: firestore.Timestamp.fromDate(new Date())
    };
    alert.date.final = firestore.Timestamp.fromDate(new Date());
    alert.active = false;
    return this.sosAlertsCollection.doc(alert.id).update(alert);
  }

  getUsers(): Observable<SosUser[]> {
    return this.sosUsers;
  }

  getUser(id: string): Observable<SosUser> {
    return this.sosUsersCollection.doc<SosUser>(id).valueChanges().pipe(
      take(1),
      map(users => {
        users.id = id;
        return users;
      })
    );
  }

  addSosUser(user: SosUser): Promise<void> {
    return this.sosUsersCollection.doc(user.id).set(user);
  }

  deleteSosUser(user: SosUser): Promise<void> {
    return this.sosUsersCollection.doc(user.id).delete();
  }


  filterSosUsers(filter: string): Observable<SosUser[]> {
    filter = filter.toLowerCase();
    if (filter.length === 0) {
      return this.sosUsersCollection.valueChanges().pipe(
        map(items => items.filter(item => item.id !== ''))
      );
    }
    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);

    return this.sosUsersCollection.valueChanges().pipe(
      map(items => items.filter(item =>
        (item.name >= startCode && item.name <= endCode)
      ))
    );
  }
}
